<template>
  <div class="page-sign d-block st py-0">
      <div class="row g-0">
          <div class="col-md-7 col-lg-5 col-xl-4 col-wrapper">
              <div class="card card-sign">
                  <div class="card-header">
                      <div class="text-center">
                          <img src="assets/images/akxalogo.png" style="width: 200px; margin-bottom:10px;" alt="" />
                      </div>
                      <div class="text-center">
                          <a href="#" class="text-center header_text mb-3 mt-0">CLIC</a>
                      </div>
                      <h3 class="card-title">Sign In</h3>
                      <p class="card-text">Welcome back! Please signin to continue.</p>
                  </div>
                  <div class="card-body">
                      <form @submit.prevent="login">
                          <div class="mb-4">
                              <label class="form-label">Username</label>
                              <input type="text" tabindex=1 class="form-control" placeholder="Enter your username" :class="{ 'is-invalid': errors.username }" v-model="user.username" ref="username" />
                              <span v-if="errors.username" class="invalid-feedback">{{ errors.username[0] }}</span>
                          </div>
                          <div class="mb-4">
                              <label class="form-label d-flex justify-content-between">Password <router-link to="/forgot_password">Forgot password?</router-link></label>
                              <input type="password" tabindex=2 class="form-control" placeholder="Enter your password" :class="{'is-invalid':errors.password}" v-model="user.password" />
                              <span v-if="errors.password" class="invalid-feedback">{{ errors.password[0] }}</span>
                          </div>
                          <button method="submit" tabindex=3 class="btn btn-primary btn-sign">Sign In</button>
                      </form>
                  </div>
              </div>
          </div>
          <div class="col d-none d-lg-block"></div>
      </div>
  </div>
</template>
<script>
    export default {
    name: "Login",
    data() {
        return {
            user: {
                username: "",
                password: "",
            },
            errors: [],
        };
    },
    mounted() {
        this.$refs.username.focus();
    },
    methods: {
        login() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store.dispatch("auth", { uri: "login", data: vm.user })
                .then(function (response) {
                    loader.hide();
                    vm.$store.dispatch("setUser", response.data.user);
                    vm.$store.dispatch("setToken", response.data.token);
                    vm.getPermissions()
                    
                })
                .catch(function (error) {
                    loader.hide();
                    if (!error.response) {
                        vm.$store.dispatch(
                            "error",
                            "Cannot reach the API. Start XAMPP (Apache) and use npm run serve at http://localhost:8080/"
                        );
                        return;
                    }
                    vm.errors = error.response.data.errors || [];
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },
        getPermissions() {
            let vm = this;
            let uri = {
                uri: 'getPermissions',
                data: {
                    role_id: this.$store.getters.user.role_id
                }
            };
            let loader = vm.$loading.show();
            this.$store.dispatch('post', uri)
            .then(response => {
                loader.hide();
                vm.$store.dispatch('setPermissions', response.data)
                vm.$router.push("/dashboard")
            })
            .catch(error => {
                loader.hide();
                vm.errors = error.response.data.errors;
                vm.$store.dispatch("error", error.response.data.message);
            })
        },
    },
};
</script>
<style>
  /* .st { */
  /* background-image: linear-gradient(to right, #053aed 40%, #323335 100%)!important; */
  /* background-image: linear-gradient(to right, #323335 40%, #053aed 100%)!important; */
  /* background-image: linear-gradient(to right, #323335 40%, #323335 100%)!important; */
  /* background-image: linear-gradient(to right, #053aed 10%, #323335 100%)!important; */
  /* } */

  .auth-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    mix-blend-mode: luminosity;
    opacity: .8!important;
}
.page-sign.d-block {
    background-image: linear-gradient(to right, #9ba9d8 40%, #5b7ce7 100%);
}
.header_text{
    font-family: "Archivo", sans-serif;
    font-weight: 600;
    display: inline-block;
    line-height: 1;
    color: #212830;
    letter-spacing: -0.5px;
    position: relative;
    font-size: 28px;
}
</style>
